var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ticker",staticClass:"c-news-ticker"},[_c('span',{ref:"line",staticClass:"c-news-line c-news-ticker__line",class:_vm.lineClass,on:{"click":_vm.onLineClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }